<template>
  <div class="feishu-group">
    <div class="feishu-group-header">
      <a-avatar class="avatar" :src="avatar" style="margin-right: 5px" />
      {{ name }}
    </div>
    <div class="feishu-group-content">
      <div class="">群名片</div>
      <div>
        <a-tag v-if="tagInfo && tagInfo.text" :color="tagInfo.color">{{ tagInfo.text }}</a-tag>
        <a-button size="small" v-if="inGroup" :href="'https://applink.feishu.cn/client/chat/open?openChatId=' + groupId" target="_blank">打开</a-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    inGroup: {
      type: Boolean,
      default: false
    },
    tagInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    groupId: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="less" scoped>
.feishu-group {
  border: 1px #f4f6f7 solid;
  border-radius: 5px;
  font-size: 14px;
  max-width: 200px;
}
.avatar {
  flex: none;
}
.feishu-group-header {
  background: #f4f6f7;
  color: #000;
  padding: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.feishu-group-content {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-all;
}
</style>
